import { Box, Card, CardContent, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import RewardTypeToggle from './RewardTypeToggle';
import CouponForm from './CouponForm';
import CashPayoutForm from './CashPayoutForm';
import { RewardType } from '../../types/campaign';

const StyledCard = styled(Card)(({ theme }) => ({
  border: '1px solid #E5E7EB',
  borderRadius: '12px',
  boxShadow: 'none',
  marginBottom: theme.spacing(3),
  backgroundColor: '#FFFFFF'
}));

interface CustomerRewardsSectionProps {
  rewardType: RewardType;
  onRewardTypeChange: (_event: React.MouseEvent<HTMLElement>, newValue: RewardType | null) => void;
  // Coupon fields
  discountAmount: string;
  couponCode: string;
  expirationDate: string;
  couponTerms: string;
  onDiscountAmountChange: (value: string) => void;
  onCouponCodeChange: (value: string) => void;
  onExpirationDateChange: (value: string) => void;
  onCouponTermsChange: (value: string) => void;
  // Cash payout fields
  cashAmount: string;
  paymentMethod: string;
  cashTerms: string;
  onCashAmountChange: (value: string) => void;
  onPaymentMethodChange: (value: string) => void;
  onCashTermsChange: (value: string) => void;
}

const CustomerRewardsSection = ({
  rewardType,
  onRewardTypeChange,
  discountAmount,
  couponCode,
  expirationDate,
  couponTerms,
  onDiscountAmountChange,
  onCouponCodeChange,
  onExpirationDateChange,
  onCouponTermsChange,
  cashAmount,
  paymentMethod,
  cashTerms,
  onCashAmountChange,
  onPaymentMethodChange,
  onCashTermsChange
}: CustomerRewardsSectionProps) => {
  return (
    <StyledCard>
      <CardContent sx={{ p: 4 }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            fontSize: '1.25rem',
            letterSpacing: '-0.015em',
            mb: 0.5,
            color: '#111827',
            fontFamily: '"Inter", sans-serif'
          }}
        >
          Customer Rewards
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mb: 3,
            color: '#6B7280',
            fontSize: '0.875rem',
            fontFamily: '"Inter", sans-serif'
          }}
        >
          Incentivize survey completion with a reward. This is sent after the survey is finished.
        </Typography>

        <RewardTypeToggle value={rewardType} onChange={onRewardTypeChange} />

        {rewardType === 'coupon' && (
          <CouponForm
            discountAmount={discountAmount}
            couponCode={couponCode}
            expirationDate={expirationDate}
            termsConditions={couponTerms}
            onDiscountAmountChange={onDiscountAmountChange}
            onCouponCodeChange={onCouponCodeChange}
            onExpirationDateChange={onExpirationDateChange}
            onTermsConditionsChange={onCouponTermsChange}
          />
        )}

        {/* Cash reward is coming soon, so hide the form */}
        {false && rewardType === 'cash' && (
          <CashPayoutForm
            cashAmount={cashAmount}
            paymentMethod={paymentMethod}
            termsConditions={cashTerms}
            onCashAmountChange={onCashAmountChange}
            onPaymentMethodChange={onPaymentMethodChange}
            onTermsConditionsChange={onCashTermsChange}
          />
        )}

        {rewardType === 'none' && (
          <Box
            sx={{
              p: 3,
              backgroundColor: '#F9FAFB',
              borderRadius: '8px',
              textAlign: 'center',
              border: '1px solid #E5E7EB'
            }}
          >
            <Typography sx={{ color: '#6B7280', fontSize: '0.875rem' }}>
              No reward will be offered for this campaign.
            </Typography>
          </Box>
        )}
      </CardContent>
    </StyledCard>
  );
};

export default CustomerRewardsSection;

